import { useHotkeys } from "react-hotkeys-hook";

import { useGlobalCommandbarStore } from "../store";
import { CommandbarShortcutKeys } from "../types/common";

export const useShortcutPressListener = () => {
  const setShotcutKeysPressed = useGlobalCommandbarStore(
    st => st.setShotcutKeysPressed,
  );

  useHotkeys(
    "meta",
    () => {
      setShotcutKeysPressed([CommandbarShortcutKeys.META]);
    },
    { keydown: true, keyup: false },
  );

  useHotkeys(
    "meta",
    () => {
      setShotcutKeysPressed([]);
    },
    { keydown: false, keyup: true },
  );

  useHotkeys(
    "meta+[",
    () => {
      setShotcutKeysPressed([]);
    },
    { keydown: false, keyup: true },
  );

  useHotkeys(
    "meta+]",
    () => {
      setShotcutKeysPressed([]);
    },
    { keydown: false, keyup: true },
  );

  useHotkeys(
    "meta+enter",
    () => {
      setShotcutKeysPressed([
        CommandbarShortcutKeys.META,
        CommandbarShortcutKeys.ENTER,
      ]);
    },
    { keydown: true, keyup: false },
  );

  useHotkeys(
    "meta+enter",
    () => {
      setShotcutKeysPressed([]);
    },
    { keydown: false, keyup: true },
  );
};
